import { ActionFunction, redirect } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { parseFormData } from "../../utils/parseFormData";

export const chatAction: ActionFunction = async ({ request, params }) => {
  const formData = await request.formData();
  const updates = parseFormData(formData, { numbers: ["hospitalId"] });
  const action = formData.get("action");

  // Silme işlemi
  if (action === "delete") {
    await axiosApi.delete(`/api/chats/${params.id}`);
    return redirect(`/chats`);
  }

  // Kaydetme işlemi
  if (params.id === "new") {
    await axiosApi.post("/api/chats", updates);
  } else {
    await axiosApi.put(`/api/chats/${params.id}`, updates);
  }

  return redirect(`/chats`);
};
